module.exports = __webpack_public_path__ + "static/media/listing-03.d0289e39.jpg";